export * from './FAQSearchResults'
